//React
import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
//Styling
import "./picklist.scss";
//MUI
import { Box, Button, TextField } from "@mui/material";
import Modal from "@mui/material/Modal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MergeIcon from "@mui/icons-material/Merge";

//Components
import MainAlert from "../reusables/MainAlert";
import Loader from "../reusables/Loader";
import PicklistRow from "./PicklistRow";
import ConfirmModal from "../reusables/ConfirmModal";
//Utils
import { handleAlert } from "../../utils/alert";
import {
  getPickListById,
  ShowMergedPicklists,
  updatePicklList,
} from "../../utils/api";
import { axiosInstance } from "../../utils/axiosInstance";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "8px",
  p: 4,
};

export default function AdminIndvPickList() {
  //URL
  const url = process.env.REACT_APP_NITROPOS;
  const navigate = useNavigate();
  //Main
  const [user, setUser] = useState<any>({});
  //Params
  const { id = "1" } = useParams();
  //Refs
  const scrollToTopRef: any = useRef();
  //Picklist
  const [picklist, setPicklist] = useState<any>({});
  const [allPickLists, setAllPickLists] = useState<any>({});

  const [boxes, setBoxes] = useState<any>(null);

  //Alert
  const [alert, setAlert] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [severity, setSeverity] = useState<any>("");
  const [loader, setLoader] = useState<boolean>(true);
  //Modals
  const [confirm, setConfirm] = useState<boolean>(false);
  const [confirmMessage, setConfirmMessage] = useState<string>("");
  const [showBoxes, setShowBoxes] = useState<boolean>(false);
  const [showCases, setShowCases] = useState<boolean>(false);

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    const buttonTd = event.currentTarget.closest("td");
    if (buttonTd) {
      const nextToNextTd =
        buttonTd.previousElementSibling as HTMLTableCellElement;
      const input = nextToNextTd.querySelector("input") as HTMLInputElement;
      console.log("actual value:", input.value);
      console.log("actual value poid:", input.dataset.poid);
      console.log("actual value product id:", input.dataset.pid);
      const newValue = input.value;
      const plHeadId = input.dataset.poid;
      const plItemId = input.dataset.pid;

      if (newValue && plHeadId && plItemId) {
        const res = await updatePicklList(
          plHeadId,
          plItemId,
          newValue,
          user?.user || "System"
        );

        if (res === "error") {
          setMessage("unable to update! please try again");
          setAlert(true);
        } else {
          setMessage("Product actual quantity has been updated");
          setAlert(true);
        }
      } else {
        setMessage("Some filed are empty! Please refresh the page");
        setAlert(true);
      }
    }
  };
  useEffect(() => {
    setLoader(true);
    //Bring in User
    let userDetails = localStorage.getItem("userDetails");
    if (userDetails) {
      let parsedUserDetails = JSON.parse(userDetails);
      setUser(parsedUserDetails);
    }
    //Bring in Picklist
    LoadPicklist();
    setLoader(false);
  }, []);
  const LoadPicklist = async () => {
    const res = await ShowMergedPicklists(id);
    console.log(res);
    setAllPickLists(res);

    if (res === "error") {
      setMessage("unable to load picklist ");
      setAlert(true);
    }
  };

  return (
    <main className="picklist">
      <h1 className="main_heading">Warehouse Picklists</h1>{" "}
      {!loader ? (
        <>
          {allPickLists.length > 0 ? (
            allPickLists &&
            allPickLists.map((picklist: any, i: any) => {
              return (
                <>
                  <p>
                    Picklist {i + 1} (
                    {picklist[0]?.orderSource || "Unknown source"})
                  </p>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Product</th>
                        <th>ordered quantity</th>
                        <th>Actual quantity</th>
                        <th>Update</th>
                      </tr>
                    </thead>

                    <tbody>
                      {picklist &&
                        picklist.map((single_picklist: any, i: any) => {
                          return (
                            <tr style={{}}>
                              <td>{single_picklist.name}</td>
                              <td>{single_picklist.originalToOrder}</td>
                              <td>
                                <TextField
                                  id="outlined-basic"
                                  variant="outlined"
                                  type="number"
                                  sx={{ width: "100px" }}
                                  inputProps={{
                                    "data-poid": id,
                                    "data-pid": single_picklist.productId,
                                  }}
                                  defaultValue={single_picklist.actualToOrder}
                                  // value={picklist.actualToOrder}
                                />
                              </td>
                              <td>
                                <Button
                                  variant="contained"
                                  onClick={handleClick}
                                >
                                  Update
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </>
              );
            })
          ) : (
            <h1 className="empty_table_heading">
              There are no picklist orders
            </h1>
          )}
        </>
      ) : (
        <Loader />
      )}
      <Modal open={alert}>
        <MainAlert message={message} severity={severity} closer={setAlert} />
      </Modal>
    </main>
  );
}
